// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"155":"02fd885f","453":"46dc3e92","832":"e56e03dd"}[chunkId] + ".chunk.js";
};